export const updateInfoFeedDisplay = (data) => {
    return {
        type: 'UPDATE_INFO_FEED_DISPLAY',
        data
    }
}

export const clearInfoFeedDisplay = () => {
    return {
        type: 'CLEAR_INFO_FEED_DISPLAY'
    }
}
